<template>
  <div class="header">
    <div class="header__img" :style="{ backgroundImage: `url(${content.image?.original})` }"></div>
    <div class="header__text">
      <h1 class="header__title">{{ content.title }}</h1>
      <h2 class="header__subtitle">{{ content.subtitle }}</h2>
    </div>
  </div>
</template>

<script>
import Image from '@/components/global/Image.vue'

export default {
  name: 'PageHeader',
  components: { Image },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
